<template lang="pug">
div
  div(v-if="ecommerce")
    div.px-2(v-if="ecommerce.sync_status === null")
      v-row
        v-col
          v-btn.white--text(block @click="syncAll" color="green" depressed) Import all products
    .sync-in-progress.mx-4(v-if="syncStatus === 'in_progress'")
      v-layout
        div.font-weight-bold Update in progress
        div.ml-2.my-auto.grey--text {{ syncDone }} / {{ syncTotal }}
      v-layout.mt-1
        v-progress-linear(color="blue" height=6 rounded :value="syncDone/syncTotal*100")
        div.ml-2(style="margin-top:-11px")
          v-icon(small color="blue") mdi-progress-clock
    .sync-in-progress.mx-4(v-if="syncStatus === 'cancelled'")
      v-layout
        div.font-weight-bold Update cancelled
        div.ml-2.my-auto.grey--text {{ syncDone }} / {{ syncTotal }}
      v-layout.mt-1
        v-progress-linear(color="warning" height=6 rounded :value="syncDone/syncTotal*100")
        div.ml-2(style="margin-top:-11px")
          v-icon(small color="warning") mdi-pause-circle-outline
    .sync-error.mx-4(v-if="syncStatus === 'error'")
      v-layout
        div.font-weight-bold Error occured
        div.ml-2.my-auto.grey--text {{ syncDone }} / {{ syncTotal }}
      v-layout.mt-1
        v-progress-linear(color="error" height=6 rounded :value="syncDone/syncTotal*100")
        div.ml-2(style="margin-top:-11px")
          v-icon(small color="error") mdi-progress-alert
    .sync-completed.mx-4(v-if="syncStatus === 'done'")
      v-layout
        div.font-weight-bold All products data updated
        div.ml-2.my-auto.grey--text {{ syncDone }} / {{ syncTotal }}
      v-layout.mt-1
        v-progress-linear(color="green" height=6 rounded :value="100")
        div.ml-2(style="margin-top:-11px")
          v-icon(small color="green") mdi-check-circle
      span.caption(v-if="ecommerce.sync_status.finished_at") Last updated on {{ ecommerce.sync_status.finished_at | convertServerDate }}
    div.px-2
      v-row(v-if="syncStatus === 'done'")
        v-col(v-if="initImport")
          v-btn.custom-transform-class.text-none(block @click="syncAll" color="accent" depressed) Import All Products
          v-btn.custom-transform-class.text-none.mt-2(block @click="syncSelected" color="warning" depressed) Import Selected products
          v-btn.custom-transform-class.text-none.mt-2(block @click="initImport = false" text) Cancel
        v-col(v-else)
          v-btn.custom-transform-class.text-none(block @click="fetchProductData" color="primary" depressed) Fetch Latest Products Data
          v-btn.custom-transform-class.text-none.mt-2(block @click="initImport = true" color="primary" depressed) Import Products
      v-row(v-if="syncStatus === 'pending' || syncStatus === 'in_progress'")
        v-col
          v-btn.custom-transform-class.text-none(block @click="stopSync" color="error" depressed) Stop Import
      v-row(v-if="syncStatus === 'cancelled' || syncStatus === 'error'")
        v-col(cols="6")
          v-btn.white--text.custom-transform-class.text-none(block @click="syncRetry" color="blue" depressed) Continue Import
        v-col(cols="6")
          v-btn.white--text.custom-transform-class.text-none(block @click="syncAll" color="green" depressed) Restart Import
</template>

<script>
import { mapActions } from "vuex"

export default {
  name: "ShopifyProductSync",
  props: ['ecommerce', 'checked', 'initImport'],
  data: (vm) => ({
    syncStatus: vm.ecommerce.sync_status.status,
    syncSource: vm.ecommerce.domain,
    syncDone: vm.ecommerce.sync_status.processed,
    syncTotal: vm.ecommerce.sync_status.total_products,
  }),
  watch: {
    ecommerce (val) {
      this.syncStatus = val.sync_status.status,
      this.syncSource = val.domain,
      this.syncDone = val.sync_status.processed,
      this.syncTotal = val.sync_status.total_products
    },
    checked: {
      deep: true,
      handler (val) {
        if (!this.initImport && val.length > 0) {
          this.initImport = true
        }
      }
    },
    initImport (val) {
      this.$emit('update:initImport', val)
    }
  },
  mounted () {
    this.$wamp.subscribe(`shopify-sync-progress:${this.ecommerce.company}`, (args, kwArgs) => {
      this.syncSource = kwArgs.source
      this.syncStatus = kwArgs.status
      this.syncDone = kwArgs.done
      this.syncTotal = kwArgs.total
      if (kwArgs.status === 'done') {
        this.$axios.get(`/ecommerce/shopify/${this.ecommerce.id}/`)
          .then(resp => {
            this.$emit('update:ecommerce', resp.data)
          })
          .catch(() => {})
      }
    })
    if (this.ecommerce.sync_status.status === 'in_progress' || this.ecommerce.sync_status.status === 'error') {
      this.syncSource = this.ecommerce.url
      this.syncStatus = this.ecommerce.sync_status.status,
      this.syncDone = this.ecommerce.sync_status.processed,
      this.syncTotal = this.ecommerce.sync_status.total_products
    }
  },
  methods: {
    ...mapActions(['showMessage']),
    fetchProductData () {
      this.$axios.post(`/ecommerce/shopify/${this.ecommerce.id}/sync_all`, { sync_product: false })
        .then(() => {
          location.reload()
        })
        .catch(() => {})
    },
    syncAll () {
      this.$axios.post(`/ecommerce/shopify/${this.ecommerce.id}/sync_all/`, { sync_product: true })
        .then(resp => {
          this.$emit('update:ecommerce', resp.data)
        })
        .catch(() => {
          this.showMessage(['error', this.$t('error_message.unable_to_update_products')])
        })
    },
    syncRetry () {
      this.$axios.post(`/ecommerce/shopify/${this.ecommerce.id}/stop_and_resume_sync/`)
        .then(resp => {
          this.$emit('update:ecommerce', resp.data)
        })
        .catch(() => {
          this.showMessage(['error', this.$t('error_message.unable_to_resume_update')])
        })
    },
    stopSync () {
      this.$axios.post(`/ecommerce/shopify/${this.ecommerce.id}/stop_sync/`)
        .then(resp => {
          this.$emit('update:ecommerce', resp.data)
        })
        .catch(() => {
          this.showMessage(['error', this.$t('error_message.unable_to_stop_update')])
        })
    },
    syncSelected () {
      this.checked.forEach(o => {
        this.$axios.post(`/ecommerce/shopify/products/${o.id}/sync_and_import_product/`)
        .then(resp => {
          let resend = {...resp.data, real_id: o.id }
          this.$emit('update:checked', resend)
          this.$emit('update:initImport', false)
          this.showMessage(['success', this.$t('success_message.product_successfully_imported')])
        })
        .catch(() => {
          this.showMessage(['error', this.$t('error_message.unable_to_update_products')])
        })
      })
    }
  }
}
</script>

<style lang="scss" scoped>

</style>